import { render } from "./PublicProfileView.vue?vue&type=template&id=b3c4d6fe"
import script from "./PublicProfileView.vue?vue&type=script&lang=js"
export * from "./PublicProfileView.vue?vue&type=script&lang=js"

import "./PublicProfileView.vue?vue&type=style&index=0&id=b3c4d6fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__